/**
 * Zeitstempel aus Microsoft Graph in ein `Date` bringen.
 *
 * Graph liefert `start.dateTime` OHNE Zonen-Suffix (die Zone steht daneben in
 * `timeZone`); die API-Antworten von KMVS sind auf UTC gestellt. Ein fehlendes
 * Suffix wird deshalb als UTC gelesen — sonst interpretiert der Browser die
 * Zeichenkette als Ortszeit und ein Termin springt um den Zonen-Versatz.
 *
 * Lag bis 14.09.2026 in `components/dashboard/DashboardShared.tsx` und wurde
 * von dort auch außerhalb des Dashboards importiert. Als reine Funktion in
 * `utils/` ist sie ohne React-Baum nutzbar (und unter vitest/node testbar);
 * DashboardShared re-exportiert sie, damit die bestehenden Importe gelten.
 */
export const toGraphDate = (dt: string): Date =>
    new Date(/Z|[+-]\d\d:?\d\d$/.test(dt) ? dt : dt + "Z");
